export var useRoundQuantityPickerState = function(param) {
    var onChange = param.onChange, value = param.value, minValue = param.minValue, maxValue = param.maxValue, stepSize = param.stepSize;
    var handleIncrement = function() {
        if (value === 0 && minValue !== undefined && minValue !== 0) {
            onChange(minValue);
        } else if (stepSize && maxValue !== undefined && value + stepSize >= maxValue) {
            onChange(maxValue);
        } else {
            if (maxValue === undefined || value < maxValue) {
                onChange(stepSize ? value + stepSize : value + 1);
            }
        }
    };
    var handleDecrement = function() {
        if (value === 0 || value === minValue) {
            onChange(0);
        } else if (stepSize && minValue !== undefined && value - stepSize <= minValue) {
            onChange(minValue);
        } else {
            if (minValue === undefined || value > minValue) {
                onChange(stepSize ? value - stepSize : value - 1);
            }
        }
    };
    var dispatcher = function(action) {
        switch(action){
            case "increment":
                handleIncrement();
                break;
            case "decrement":
                handleDecrement();
                break;
            default:
                break;
        }
    };
    return [
        value,
        dispatcher
    ];
};
